module.exports = __webpack_public_path__ + "static/media/battleship.70dbd500.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/battleship.png
// module id = 142
// module chunks = 0